import Crear from "./Crear";
import Editar from "./Editar";
import Ver from "./Ver";

const paginas = { Crear, Editar, Ver };
export default paginas;
